import $ from "jquery";

const SearchInput = () => {
	function init() {
		handleSearchButon();
	}

	function handleSearchButon() {
		$(document).on("click", ".js-search-btn", function (e) {
			e.preventDefault();
			let $e = $(this);
			let $selector = $($e.data("input"));
			let inputValue = $selector.val();
			window.location = "/?s=" + inputValue;
		});
	}

	init();
};

export default SearchInput;
